export default __webpack_public_path__ + "static/media/icon_artifact_medium_orange.96ea6b84.svg";